module.exports = __webpack_public_path__ + "img/logo.761ea32b.svg";